export default "__VITE_ASSET__BRFbjEJd__"